import { forwardRef } from 'react';
import { StyledModalPart } from './styled';

const ModalPart = forwardRef((props, ref) => (
  <StyledModalPart ref={ref} {...props} />
));

export default ModalPart;
